import React from 'react';

import { KeyOutlined, ApiOutlined, CarOutlined } from '@ant-design/icons';
import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';
import { Form, Input, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

const CyberbizCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  const isEditing = !!ecAccount?.id;
  const accessTokenDirty = useDirtyMaskedField(form, [ 'credentials', 'access_token' ], isEditing);

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'email']}
            label={t('models.ec_account.platform_settings.cyberbiz.email')}
            tooltip={t('models.ec_account.platform_settings.cyberbiz.email_hint')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.cyberbiz.email_required') }]}
          >
            <Input
              type="email"
              placeholder={t('models.ec_account.platform_settings.cyberbiz.email_placeholder')}
              prefix={<ApiOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'access_token']}
            label={t('models.ec_account.platform_settings.cyberbiz.access_token')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.cyberbiz.access_token_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.cyberbiz.access_token_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={accessTokenDirty}
            />
          </Form.Item>
        </Col>

        {/* 選填：僅以黑貓宅急便出貨時，列印托運單需要貨主自己的黑貓客代 */}
        <Col span={12}>
          <Form.Item
            name={['credentials', 'tcat_customer_code']}
            label={t('models.ec_account.platform_settings.cyberbiz.tcat_customer_code')}
            tooltip={t('models.ec_account.platform_settings.cyberbiz.tcat_customer_code_hint')}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.cyberbiz.tcat_customer_code_placeholder')}
              prefix={<CarOutlined />}
            />
          </Form.Item>
        </Col>

        {/* 選填：僅以宅配通出貨時，列印托運單需要貨主自己的宅配通客代 */}
        <Col span={12}>
          <Form.Item
            name={['credentials', 'ecan_customer_code']}
            label={t('models.ec_account.platform_settings.cyberbiz.ecan_customer_code')}
            tooltip={t('models.ec_account.platform_settings.cyberbiz.ecan_customer_code_hint')}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.cyberbiz.ecan_customer_code_placeholder')}
              prefix={<CarOutlined />}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default CyberbizCredentials;
